import React, { memo } from 'react';
import TripleColumnContainer from '../../Layout/Containers/TripleColumnContainer';
import styles from './customers.module.scss';

const CustomersInsurance = () => (
    <TripleColumnContainer>
        <div className={styles.customersContainer}>
            <div className={styles.customerContainer}>
                <img src="/images/customers/bud-og-hustad.webp" />
                <p>
                    Bud & Hustad Forsikring Gjensidig is a mutual insurance company originally
                    founded in 1910 and specialising in marine insurance. The company cooperates
                    with Gjensidige Forsikring ASA
                </p>
            </div>
            <div className={styles.customerContainer}>
                <img src="/images/customers/dnk.svg" />
                <p>
                    The predecessor of DNK was established in 1914, when the outbreak of WW1 induced
                    a need for an institution dedicated to ensure the marine sector insurance cover
                    against war perils. The Norwegian Ship-owners’ Mutual War Risks Insurance
                    Association was established in its current form in 1935.
                </p>
            </div>
            <div className={styles.customerContainer}>
                <img src="/images/customers/gard.webp" />
                <p>
                    Gard was founded in 1907 as a Protection & Indemnity club and is today one of
                    the world’s leading marine insurers, with headquarters in Norway and offices
                    around the world. Among its clients are ship-owners and operators, shipyards,
                    and companies in the upstream oil and gas markets.
                </p>
            </div>
            <div className={styles.customerContainer}>
                <img src="/images/customers/gjensidige.svg" />
                <p>
                    Gjensidige is a leading Nordic general insurance company operating in Norway,
                    Denmark, Sweden and the Baltic. It also offers bank-, pension- and savings
                    products in Norway. Gjensidige cooperates with our customers Bud & Hustad,
                    Havtrygd and Nordlys on its marine portfolio.
                </p>
            </div>
            <div className={styles.customerContainer}>
                <img src="/images/customers/havtrygd.webp" />
                <p>
                    Havtrygd is a mutual insurance company originally founded by fishermen in 1927
                    and specializing in insuring fishing boats and other coastal tonnage. The
                    company cooperates with Gjensidige Forsikring ASA.
                </p>
            </div>
            <div className={styles.customerContainer}>
                <img src="/images/customers/industriforsikring.webp" style={{ width: '90%' }} />
                <p>
                    Founded by Hydro in 1920, Industriforsikring was the first Norwegian captive
                    insurance company. Industriforsikring provides property damage, business
                    interruption, cargo and third party liability coverage for subsidiary companies
                    of the Hydro Group.
                </p>
            </div>
            <div className={styles.customerContainer}>
                <img src="/images/customers/marsh.webp" />
                <p>
                    Marsh is the world's leading provider of risk and insurance services and
                    solutions. Twenty-seven thousand employees collaborate with customers in more
                    than 100 countries to define, design and deliver branch-specific solutions for
                    their business
                </p>
            </div>
            <div className={styles.customerContainer}>
                <img src="/images/customers/ms.webp" style={{ width: '90%' }} />
                <p>
                    Marine Insurance Services is based in Riga, Latvia and provides marine and
                    transport insurance for the Baltic countries. Being a full-service company it
                    also provides non-marine insurance and insurance related services for their
                    customers.
                </p>
            </div>
            <div className={styles.customerContainer} style={{ visibility: 'hidden' }}></div>
        </div>
    </TripleColumnContainer>
);

export default memo(CustomersInsurance);
